import ManageConstante from '@/views/consultations/en-cours/constantes/manage-constante'

export default {
    name: 'constantes',
    components: {
        ManageConstante
    },
    props: {
        consultation: Object,
        section_name: String,
        evolution_id: Number,
        evolution_toggler: Number,
        current_consultation_evolution: Number,
        is_start: Number,
        user_info: Object,
    },
    data() {
        return {
            is_loading: true,
            is_empty: false,
            modal_toggler: 0,
            selected_constant: {},
            data_to_be_deleted: {},
            info_user: {},
        };
    },

    watch: {
        evolution_toggler() {
            this.refreshConstantes()
            this.userInfoSetter()
        }
    },

    computed: {
        consultation_constantes() {
            return this.$store.getters["consultation_constantes"];
        },

        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        evolution_id_initiale() {
            return this.$store.getters['evolution_id_initiale']
        }
    },

    async mounted() {

    },

    methods: {
        userInfoSetter() {
            this.info_user = {
                nom_medecin: this.user_info.user,
                titre: this.user_info.titre
            }
        },

        refreshConstantes() {
            this.is_loading = true

            let data = {
                consultation_id: this.consultation.id,
                type_consultation_id: this.consultation.tarif_consultation.type_consultation_id,
                evolution_id: this.evolution_id_initiale,
                est_en_cours: true 
            }

            this.$store.dispatch('getConsultationConstante', data).then(() => {
                if (this.consultation_constantes.length == 0) {
                    this.is_empty = true
                } else {
                    this.is_empty = false
                }

                this.is_loading = false
            })
        },

        addConstante() {
            this.modal_toggler = (this.modal_toggler === 0)?1:0

            this.selected_constant = {
                constante_group_id: 0
            }
        },

        editConstant(cste) {
            this.modal_toggler = (this.modal_toggler === 0)?1:0
            this.selected_constant = cste
        },

        removeGroupConstante(constante) {
            console.log(constante);
            
            this.data_to_be_deleted = {
                data_type: 'constante',
                libelle: constante.reference,
                consultation_id: this.consultation.id,
                evolution_id: this.evolution_id,
                user_id: this.user_info.id,
                group_id: constante.constante_group_id
            }
        }
    }
}


